import axios from 'axios';
import { IUserV2 } from '../../../types';

interface IParams {
  file: File;
  attachmentId: string;
  formId: string;
  filledFormId: string;
  answerIndex: string;
  fId: string;
  extension: string;
  context: {
    apiUrl: string;
    publicRG?: boolean;
    user?: IUserV2;
  };
}

/**
 * Ask the server for a pre-signed url to upload a file to s3
 * @returns
 */
function uploadFileS3({
  file,
  attachmentId,
  formId,
  filledFormId,
  answerIndex,
  fId,
  extension,
  context,
}: IParams): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    const { apiUrl, user } = context;

    if (apiUrl && user) {
      const credentials: any = user.credentials;
      let url = `${apiUrl}/main_api/v1/files/root_gizmo_data/url?`;
      url += `attachmentId=${attachmentId}&formId=${formId}&filledFormId=${filledFormId}&`;
      url += `fId=${fId}&answerIndex=${answerIndex}&extension=${extension}`;

      try {
        const response = await axios({
          method: 'POST',
          url,
          headers: {
            ...credentials,
          },
        });

        if (response.status === 200) {
          const presignedUrl = response.data.presigned_url;

          await axios({
            method: 'PUT',
            url: presignedUrl,
            data: file,
            headers: {
              'Content-Type': 'application/octet-stream',
            },
          });
        }
      } catch (e) {
        reject(e);
      }
    }

    resolve();
  });
}

export default uploadFileS3;
